import { useState, useEffect } from 'react';
import HttpService from '../../services/HttpService';


/**
 * Custom hook for fetching a single klant (customer) with proper state management
 */
const useKlant = (id) => {
    const [klant, setKlant] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchKlant = async () => {
            try {
                const url = `${process.env.REACT_APP_API_URL}/Klanten/${id}`;
                const httpService = HttpService;
                httpService.configure();
                const axios = httpService.getAxiosClient();
                setLoading(true);
                setError(false);
                const klantResponse = await axios.get(url);
                const artiArray = klantResponse.data.abonnementen.flatMap(abo => abo.interfaces.map(inter => inter.artikelNr));
                const artiOmsResponse = await axios({
                    method: "QUERY",
                    url: `${process.env.REACT_APP_API_URL}/Artikelen`,
                    data: artiArray
                });
                klantResponse.data.abonnementen.forEach(abo => {
                    abo.interfaces.forEach(inter => {
                        const matchingArtiOms = (artiOmsResponse.data.find(arti => arti.mkg_artikelnr === inter.artikelNr)).omschrijving;
                        if(matchingArtiOms) inter.artiOms = matchingArtiOms;
                    })
                });
                setKlant(klantResponse.data);
            } catch (err) {
                console.error("Error fetching klant:", err);
                setError(true);
                setKlant(null);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchKlant();
        }   
    }, [id]);

    return { klant, loading, error };
};

export default useKlant;